import { DataContext } from 'components/common-form/contexts/DataContext';
import { useCallback, useContext, useMemo } from 'react';

export function useData<T = unknown, V = T extends readonly any[] ? T : Nullable<T>>(
  fieldId: string,
  defaultValue?: V,
): [Readonly<V>, (value: Readonly<V>) => void] {
  const [dataById, { setFieldValue }] = useContext(DataContext);

  const value = dataById[fieldId] as Readonly<V>;
  const setValue = useCallback(
    (val: unknown) => {
      setFieldValue(fieldId, val);
    },
    [fieldId, setFieldValue],
  );

  return useMemo(() => [value ?? defaultValue, setValue], [value, setValue, defaultValue]);
}

export const productTypeDataId = 'ProductType';
export const productSubtypeDataId = 'ProductSubtype';

export function useProductData() {
  const [dataById] = useContext(DataContext);

  const productType = dataById[productTypeDataId] as string;
  const productSubtype = dataById[productSubtypeDataId] as string;

  return { productType, productSubtype };
}
